/* eslint-disable max-len */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, Injectable } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { SearchPipe } from './search.pipe';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { Angular2SignaturepadModule } from 'angular2-signaturepad';


// Calendar
// import { CalendarModule, DateAdapter } from 'angular-calendar';
// import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';


import { AppComponent } from './app.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app.routing.module';

// angular material module start
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
// angular material module end

import { MatInputModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MAT_DIALOG_DATA, MatDatepickerModule, MatDialogRef } from '@angular/material';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CdkTableModule } from '@angular/cdk/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SideNavServiceService } from './services/side-nav-service.service';
import { MomentModule } from 'ngx-moment';
// import { ColorPickerModule } from 'ngx-color-picker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FilterPipeModule } from 'ngx-filter-pipe';
// import { NgCircleProgressModule } from 'ng-circle-progress';
import { Select2Module } from 'ng2-select2';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RoundProgressModule } from 'angular-svg-round-progressbar';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { AuthInterceptor } from './intercaptor';
import { SubmissionComponent } from './submission/submission.component';
import { InstructorSubmissionComponent } from './submission/instructor-submission/instructor-submission.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DragDropDirective } from './drag-drop.directive';
import { AuthGuard } from './auth.guard';
import { AppPasswordDirective } from './app-password.directive';
import { ContextMenuModule } from 'ngx-contextmenu';
import { DeleteConfirmModalComponent } from './commons/delete-confirm-modal/delete-confirm-modal.component';
import { SideNavFixedComponent } from './side-nav-fixed/side-nav-fixed.component';
import { SafePipe } from './safe.pipe';
import { PaginationComponent } from './commons/pagination/pagination.component';
import { SearchComponent } from './commons/search/search.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { SignaturePadComponent } from './commons/signature-pad/signature-pad.component';

import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { GlobalErrorHandler } from './services/error-handler';
import { InductionRecordsComponent } from './induction/induction-records/induction-records.component';
import { VideoPreviewComponent } from './commons/video-preview/video-preview.component';
import { NotificationComponent } from './notification/notification.component';
import { AddAccidentModalComponent } from './accident/add-accident-modal/add-accident-modal.component';
import { AddUserModalComponent } from './accident/add-user-modal/add-user-modal.component';
import { AgmCoreModule } from '@agm/core';

// FireBase Module


import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
// import { environment } from '../environments/environment';
// import { firebaseEnv } from '../environments/environment'
import { fire } from '../environments/firebase.config';
import { ToastrModule } from 'ngx-toastr';
import { TimeAgoPipe } from 'time-ago-pipe';
// import { DatePickerComponent } from './commons/date-picker/date-picker.component';

import { SharedModule } from './shared.module';
import { MaterialsModule } from './materials.module';
// import { DatePickerComponent } from './commons/date-picker/date-picker.component';
import { AddAssetTypeComponent } from './asset/add-asset-type/add-asset-type.component';
import { AddAssetComponent } from './asset/add-asset/add-asset.component';
// import { AssetsAllocationModalComponent } from './asset/assets-allocation-modal/assets-allocation-modal.component';
// import { MatTabComponent } from './commons/mat-tab/mat-tab.component';

import { MatTabComponent } from './commons/mat-tab/mat-tab.component';

import { LearnerSingleWeekComponent } from '../app/time-sheet/learner-single-week/learner-single-week.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { PreferencesComponent } from './commons/preferences/preferences.component';

// IMPORT MODULES HERE
import { CurrencyInputDirective } from './currency-input.directive';
import { CommonModule } from '@angular/common';

import { MainJobModule } from './jobs/main-job/main-job.module';
// import { MaterialsModule } from './materials.module';
import { MainAttendanceModule } from './attendance/main-attendance/main-attendance.module';
import { MainClientModule } from './clients/main-client/main-client.module';
import { MainCourseModule } from './courses/main-course/main-course.module';
import { MainDocumentModule } from './documents/main-document/main-document.module';
import { MainFolderModuleModule } from './folder/main-folder-module/main-folder.module';
import { MainLearnerModule } from './learners/main-learner/main-learner.module';
import { CompetencyModule } from './competency/competency.module';
// import { CompetencesComponent } from './staff/competences/competences.component';
// import { MainPortfolioModule } from './portfolio/main-portfolio/main-portfolio.module';
import { AuthGuardLazyLoad } from './authlazyload.guard';
import { MainStaffModule } from './staff/main-staff/main-staff.module';
import { FileTileComponent } from './commons/file-tile/file-tile.component';
import { MainQuizModule } from './quiz/main-quiz/main-quiz.module';
import { LabourJobModule } from './labour-job/labour-job/labour-job.module';
import { DigitalCardComponent } from './digital-card/digital-card.component';
import { CommentsComponent } from './commons/comments/comments.component';
import { MultiJobListComponent } from './multi-job-list/multi-job-list.component';
import { MultipleUserListComponent } from './multiple-user-list/multiple-user-list.component';
import { LearnerListComponent } from './learners/learner-list/learner-list.component';
// import { CreateEditPlantAssetComponent } from './plant-asset/create-edit-plant-asset/create-edit-plant-asset.component';
// import { CreateEditFixedAssetComponent } from './fixed-asset/create-edit-fixed-asset/create-edit-fixed-asset.component';
// import { CourseSignaturePadComponent } from './portfolio/course-signature-pad/course-signature-pad.component';
// import { BreathAlcoholFormComponent } from './medical/breath-alcohol-form/breath-alcohol-form.component';
// import { PoctTestFormComponent } from './medical/poct-test-form/poct-test-form.component';
// import { TrainingJobDatesComponent } from './jobs/training-job-dates/training-job-dates.component';

@NgModule({
  declarations: [
    AppComponent,
    TopNavComponent,
    DashboardComponent,
    LearnerSingleWeekComponent,
    LoginComponent,
    SubmissionComponent,
    InstructorSubmissionComponent,
    ForgotpasswordComponent,
    ResetPasswordComponent,
    DragDropDirective,
    AppPasswordDirective,
    SearchPipe,
    DeleteConfirmModalComponent,
    SideNavFixedComponent,
    SafePipe,
    PaginationComponent,
    SearchComponent,
    ServerErrorComponent,
    SignaturePadComponent,
    InductionRecordsComponent,
    VideoPreviewComponent,
    NotificationComponent,
    AddAccidentModalComponent,
    AddUserModalComponent,
    AddAssetTypeComponent,
    AddAssetComponent,
    PreferencesComponent,
    DigitalCardComponent,
    MultiJobListComponent,
    MultipleUserListComponent,
    // CreateEditPlantAssetComponent,
    // CreateEditFixedAssetComponent,
    // CourseSignaturePadComponent,
    // BreathAlcoholFormComponent,
    // PoctTestFormComponent,
    // LearnerListComponent,
    // TrainingJobDatesComponent,
    // CommentsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgSelectModule,
    NgxDaterangepickerMd.forRoot(),
    Select2Module,
    NgxMaterialTimepickerModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MomentModule,
    RoundProgressModule,
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory
    // }),
    NgbModule,
    // CdkTableModule,
    // ColorPickerModule,
    ImageCropperModule,
    RecaptchaV3Module,
    FilterPipeModule,
    Angular2SignaturepadModule,
    ContextMenuModule.forRoot({
      useBootstrap4: true,
    }),
    // NgCircleProgressModule.forRoot({}),
    MatDatepickerModule,


    // angular material import start here

    MatSnackBarModule, MatBadgeModule, MatTooltipModule, MatDialogModule, MatSidenavModule, MatButtonModule,
    MatCheckboxModule, MatToolbarModule, MatPaginatorModule, MatProgressSpinnerModule, MatCardModule, MatIconModule,
    MatGridListModule, MatSortModule, MatChipsModule, MatSlideToggleModule, MatListModule, MatRadioModule,
    MatMenuModule, MatTableModule, MatInputModule, MatFormFieldModule,
    MatTabsModule, MatStepperModule, MatAutocompleteModule,
    // angular material import end here

    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production, registrationStrategy: 'registerImmediately' }),
    // FIREBASE IMPORTS

    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(fire.firebase),
    ToastrModule.forRoot(),
    // AgmCoreModule.forRoot({
    //   // apiKey: 'AIzaSyDd87HP0BvoVCE1wkiQrAyNX63YPPGhXBM',
    //   apiKey: 'AIzaSyAyhV9Ddh6yJwNyfw_wy3QtAisaMGSbmpg',
    //   libraries: ['places']
    // }),

    // IMPORT ALL MODULES FILE HERE

    MainJobModule,
    MaterialsModule,
    MainAttendanceModule,
    MainCourseModule,
    MainDocumentModule,
    MainFolderModuleModule,
    MainLearnerModule,
    CompetencyModule,
    MainStaffModule,
    MainQuizModule,
    MainClientModule,
    LabourJobModule
    // MainPortfolioModule
    // MainClientModule
  ],
  entryComponents: [
    // AssetsAllocationModalComponent,
    AddAssetComponent,
    DeleteConfirmModalComponent,
    SignaturePadComponent,
    AddAccidentModalComponent,
    AddUserModalComponent,
    AddAssetTypeComponent,
    PreferencesComponent,
    FileTileComponent,
  ],
  // exports: [SponsorPackComponent, SponsorPackPolicyComponent],
  providers: [AuthGuardLazyLoad, SideNavServiceService, DatePipe, MatDatepickerModule, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LfDFNsrAAAAAJDBvLXtmrU1xigkHPdhFRtmuls_' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    AuthGuard,
    CurrencyPipe
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
// @Injectable({
//   providedIn: UserSingleWeekComponent
// })

export class AppModule {
}